module.exports = __webpack_public_path__ + "static/img/10014 (1).b23d02f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10014 (1).webp
// module id = 4iaD
// module chunks = 14